import React from 'react'
import CommentForm from './CommentForm'
import {Offcanvas} from 'react-bootstrap'

const AddComment = ({show,setShow,listingId}) => {
    
  return (
    <Offcanvas show={show} onHide={()=>setShow(false)} placement="end" >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Add Comment</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <CommentForm setShow={setShow} listingId={listingId}/>
        </Offcanvas.Body>
      </Offcanvas>
  )
}

export default AddComment